import * as React from "react";
import MimoLogo from "../../containers/layout/sidebar/mimoLogo";
import { Button } from "react-bootstrap";
import { MicrosoftIcon } from "../../components/ui/icons";
import { GoogleIcon } from "../../components/ui/icons";
import { useLogin } from "./useLogin";
import ResetPassword from "../../components/modals/sendResetPasswordEmail";
import { SignInProvider } from "../../common/constants";
import TextInputField from "../../components/ui/textInputField";
import { envDisplay } from "../../config/index";
import Spinner from "../../components/ui/spinner";
import "./login.scss";
import { Notification } from '../../components/notification';

const Login = () => {
  const {
    userEmail,
    isValidEmail,
    userPassword,
    isLoading,
    showForgotPassword,
    signInUser,
    handleOnChange,
    handlePasswordChange,
    setShowForgotPassword,
    forgotPassword,
  } = useLogin();

  return (
    <>
      <Spinner isActive={isLoading} />
      <div className="login_container">
        <Notification />
        {showForgotPassword && (
          <ResetPassword show={showForgotPassword} onHide={forgotPassword} />
        )}
        <MimoLogo />
        <div className="login-content">
          <h1>Log In</h1>
          <hr />
          <div className="device-setup-input">
            <TextInputField
              heading=""
              placeholder="Enter your email ID"
              ariaLabel="email-address"
              value={userEmail}
              type="email"
              onChange={(e) => handleOnChange(e)}
            />
            {!isValidEmail && (
              <span style={{ color: "red" }}>
                {" "}
                Please enter valid email address
              </span>
            )}
            <div className="password">
              <TextInputField
                heading=""
                placeholder="Enter your password"
                ariaLabel="password"
                value={userPassword}
                type="password"
                onChange={(e) => handlePasswordChange(e)}
              />
            </div>
            <div className="forgot-password-wrapper">
              <span
                className="forgot-password"
                onClick={() => setShowForgotPassword(true)}
              >
                Forgot Password?
              </span>
            </div>
            <Button
              type="button"
              onClick={() => {
                signInUser(SignInProvider.EMAIL);
              }}
              disabled={!isValidEmail||!userEmail}
            >
              Log In
            </Button>
          </div>
          <h2>or</h2>
          <Button
            type="button"
            style={{ marginTop: "2px" }}
            onClick={() => {
              signInUser(SignInProvider.MICROSOFT);
            }}
          >
            <MicrosoftIcon /> Log In with Microsoft
          </Button>
          <Button
            type="button"
            onClick={() => {
              signInUser(SignInProvider.GOOGLE);
            }}
          >
            <GoogleIcon /> Log In with Google
          </Button>
        </div>
      </div>
    </>
  );
};

export default Login;
